import {
    DATA_TYPE,
    COMMUNICATION_FORMAT,
    DATA_FORMAT,
    DOMAIN_MAX_LENGTH,
} from "../constants";

export const webhookSchema = {
    "webhook": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "name": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "httpRequestUrl": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.URL,
            value: "",
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    },

    "webhookHistory": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "result": {
            type: DATA_TYPE.TEXT,
            enum: "WebhookHistoryResult",
            value: "",
        },
        "event": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "eventType": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "eventDomainName": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "webhookName": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "requestUrl": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.URL,
            value: "",
        },
        "responseResult": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "httpStatusCode": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "attemptCount": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "requestedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "lastProcessedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    },

    "hookEvent": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "type": {
            type: DATA_TYPE.ENUM,
            enum: "HookEventType",
            value: null,
        },
        "domain": {
            type: DATA_TYPE.ENUM,
            enum: "HookEventDomain",
            value: null,
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    },

    "webhookHistoryAttempt": {
        "sequence": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "result": {
            type: DATA_TYPE.TEXT,
            enum: "WebhookHistoryResult",
            value: "",
        },
        "responseResult": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "httpStatusCode": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "processedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
    }
} as const;
